import React, { useState } from 'react';
import { Globe } from 'lucide-react';
import { useLanguage } from '../hooks/useLanguage';
import { reportingAgencies } from '../data/reportingAgencies';
import { ReportingAgencyCard } from '../components/ReportingAgencyCard';
import { SEO } from '../components/SEO';
export function WhereToReportPage() {
  const {
    t
  } = useLanguage();
  const [activeTab, setActiveTab] = useState<'Indonesia' | 'ASEAN' | 'International'>('Indonesia');
  const filteredAgencies = reportingAgencies.filter(agency => {
    if (activeTab === 'Indonesia') return agency.country === 'Indonesia';
    if (activeTab === 'International') return agency.country === 'International';
    return agency.country !== 'Indonesia' && agency.country !== 'International';
  });
  const tabs = [{
    id: 'Indonesia' as const,
    label: t('report.indonesia')
  }, {
    id: 'ASEAN' as const,
    label: t('report.aseanRegion')
  }, {
    id: 'International' as const,
    label: t('report.international')
  }];
  return <div className="container mx-auto px-4 sm:px-6 lg:px-8 pt-24 pb-12 sm:pb-16" data-id="element-1118">
      <SEO title={t('seo.report.title')} description={t('seo.report.desc')} data-id="element-1119" />
      <div className="text-center mb-8 sm:mb-12" data-id="element-1120">
        <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-3 sm:mb-4 px-4" data-id="element-1121">
          {t('report.title')}
        </h1>
        <p className="text-sm sm:text-base text-gray-600 max-w-2xl mx-auto px-4" data-id="element-1122">
          {t('report.subtitle')}
        </p>
      </div>

      {/* Tabs - Mobile Responsive */}
      <div className="flex justify-center mb-8 sm:mb-12 overflow-x-auto pb-2" data-id="element-1123">
        <div className="bg-gray-100 p-1.5 rounded-xl inline-flex min-w-full sm:min-w-0" data-id="element-1124">
          {tabs.map(tab => <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`flex-1 sm:flex-none px-4 sm:px-6 py-2.5 sm:py-3 rounded-lg text-xs sm:text-sm font-medium transition-all whitespace-nowrap touch-manipulation ${activeTab === tab.id ? 'bg-white shadow text-primary font-bold' : 'text-gray-500 hover:text-gray-900 hover:bg-gray-200/50'}`} data-id="element-1125">
              {tab.label}
            </button>)}
        </div>
      </div>

      {/* Grid - Responsive */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6" data-id="element-1126">
        {filteredAgencies.map((agency, index) => <ReportingAgencyCard key={index} agency={agency} data-id="element-1127" />)}
      </div>

      {/* Empty State */}
      {filteredAgencies.length === 0 && <div className="text-center py-12 text-gray-500" data-id="element-1128">
          <p className="text-sm sm:text-base" data-id="element-1129">{t('report.noAgencies')}</p>
        </div>}

      {/* Info Section - Responsive */}
      <div className="mt-12 sm:mt-16 bg-blue-50 rounded-xl sm:rounded-2xl p-6 sm:p-8 text-center border border-blue-100" data-id="element-1130">
        <Globe className="h-10 w-10 sm:h-12 sm:w-12 text-blue-600 mx-auto mb-3 sm:mb-4" data-id="element-1131" />
        <h3 className="text-lg sm:text-xl font-bold mb-2 px-4 text-blue-900" data-id="element-1132">
          {t('report.crossBorder')}
        </h3>
        <p className="text-sm sm:text-base text-blue-800 mb-4 sm:mb-6 max-w-2xl mx-auto px-4" data-id="element-1133">
          {t('report.crossBorderDesc')}
        </p>
      </div>
    </div>;
}